export const fetchCartWidgetSuggestionsSuccessHandler = (state, {
  label,
  response: {
    data: {
      products
    }
  }
}) => ({
  ...state,
  widgetSuggestions: {
    ...state.widgetSuggestions,
    [label]: products.map(suggestion => ({
      ...suggestion,
      suggestionId: `${suggestion.metadatas.suggest_id}-${suggestion.metadatas.suggest_rank}`
    }))
  }
});
export const removeSuggestionOptimisticHandler = (state, {
  suggestionId,
  cartId
}) => ({
  ...state,
  widgetSuggestions: {
    ...state.widgetSuggestions,
    [cartId]: state.widgetSuggestions[cartId].filter(({
      suggestionId: sId
    }) => sId !== suggestionId)
  }
});